import styled from 'styled-components';
import cssIngka from '@ingka/variables/colours-css';

export const PillButton = styled.div`
  margin-top: auto;
  margin-right: auto;
`;

export const PillDropdownContainer = styled.div`
  position: absolute;
`;

export const DropdownContent = styled.div`
  margin-top: 8px;
  min-width: 300px;
  padding-top: 12px;
  padding-bottom: 24px;
  padding-right: 24px;
  padding-left: 24px;
  position: absolute;
  background: ${cssIngka.colourNeutral1};
  z-index: 3;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.25);
  border: 1px solid ${cssIngka.colourNeutral4};
  & > * {
    margin-top: 12px;
    &:last-child {
      margin-right: 0px;
    }
  }
`;

export const RemovePillContainer = styled.div`
  margin-bottom: 24px;
`;

export const RemovePillWrapper = styled.div`
  display: inline-block;
  margin-right: 12px;
  margin-bottom: 12px;
  flex-grow: 0;
`;
